"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OMMRequestType = exports.OMMResponseType = exports.OMMResponseStateType = void 0;
var OMMResponseStateType;
(function (OMMResponseStateType) {
    OMMResponseStateType["Open"] = "Open";
    OMMResponseStateType["Closed"] = "Closed";
    OMMResponseStateType["ClosedRecover"] = "ClosedRecover";
    OMMResponseStateType["NonStreaming"] = "NonStreaming";
    OMMResponseStateType["Redirected"] = "Redirected";
})(OMMResponseStateType || (exports.OMMResponseStateType = OMMResponseStateType = {}));
var OMMResponseType;
(function (OMMResponseType) {
    OMMResponseType["Status"] = "Status";
    OMMResponseType["Error"] = "Error";
    OMMResponseType["Ping"] = "Ping";
    OMMResponseType["Pong"] = "Pong";
    OMMResponseType["Update"] = "Update";
    OMMResponseType["Refresh"] = "Refresh";
})(OMMResponseType || (exports.OMMResponseType = OMMResponseType = {}));
var OMMRequestType;
(function (OMMRequestType) {
    OMMRequestType["Close"] = "Close";
    OMMRequestType["Pong"] = "Pong";
    OMMRequestType["Ping"] = "Ping";
    OMMRequestType["Request"] = "Request";
    OMMRequestType["Post"] = "Post";
})(OMMRequestType || (exports.OMMRequestType = OMMRequestType = {}));
